export default {
  '新增计划':'新增計劃',
  '计划名称':'計劃名稱',
  '请输入计划名称':'請輸入計劃名稱',
  '内容及范围':'內容及範圍',
  '测试类型':'測試類型',
  '体测模拟':'體測模擬',
  '体考模拟':'體考模擬',
  '测试标准':'測試標準',
  '请选择测试标准':'請選擇測試標準',
  '测试项目':'測試項目',
  '项目与分值':'項目與分值',
  '项目满分':'項目滿分',
  '总满分':'總滿分',
  '必考':'必考',
  '一类选考项目':'一類選考項目',
  '二类选考项目':'二類選考項目',
  '不限':'不限',
  '仅限男':'僅限男',
  '仅限女':'僅限女',
  '请输入分值':'請輸入分值',
  '计算方式':'計算方式',
  '请输入总满分':'請輸入總滿分',
  '请填写计算方式':'請填寫計算方式',
  '精度':'精度',
  '取值方式':'取值方式',
  '整数':'整数',
  '小数点后一位':'小數點後一位',
  '小数点后两位':'小數點後兩位',
  '小数点后三位':'小数點後三位',
  '四舍五入':'四捨五入',
  '向上取整':'向上取整',
  '向下取整':'向下取整',
  '最终总分数':'最終總分數',
  '是否报名':'是否報名',
  '是':'是',
  '否':'否',
  '测试报告':'測試報告',
  '线上支付':'線上支付',
  '请输入':'請輸入',
  '元':'元',
  '线下支付':'線下支付',
  '免费':'免费',
  '测试范围':'測試範圍',
  '请选择测试范围':'請選擇測試範圍',
  '请填写计划名称':'請填寫計劃名稱',
  '请选择测试时间':'請選擇測試時間',
  '请选择测试类型':'請選擇測試類型',
  '请选择测试项目':'請選擇測試項目',
  '请填写测试项目分值':'請填寫測試項目分值',
  '请输入项目分值':'請輸入項目分值',
  '请输入项目计算方式':'請輸入項目計算方式',
  '一类选考项目需填写相同分值':'一類選考項目需填寫相同分值',
  '二类选考项目需填写相同分值':'二類選考項目需填寫相同分值',
  '请填写最终总分数计算方式':'請填寫最終總分數計算方式',
  '请输入有效的计算方式':'請輸入有效的計算方式',
  '请选择是否报名':'請選擇是否報名',
  '请选择测试报告支付方式':'請選擇測試報告支付方式',
  '金额至少为':'金額至少為0.01',
  '请选择测试班级':'請選擇測試班級',
  '是否取消':'是否取消',
  '取消后，页面数据不做保存':'取消後，頁面數據不做保存',
  '查看计划':'查看計劃',
  '详情':'詳情',
  '报名':'報名',
  '已报名':'已報名',
  '未报名':'未報名',
  '明细':'明細',
  '报名模板':'報名模板',
  '批量成绩导入失败列表':'批量成績導入失敗列表',
  '姓名与学籍号与失败原因':'姓名,學籍號,失敗原因',
  '组织测试列表':'組織測試列表',
  '确认要提前结束该计划':'確認要提前結束該計劃：',
  '计划结束后不再支持学生测试':'計劃結束後不再支持學生測試',
  '确认要删除该计划':'確認要刪除該計劃：',
  '删除后将无法查看本计划数据':'刪除後將無法查看本計劃數據',
  '参与机构':'參與機構',
  '测试名称':'測試名稱',
  '测试周期':'測試週期',
  '成绩导入':'成績導入',
  '成绩导出':'成績導出',
  '测试记录导出':'測試記錄導出',
  '测试记录':'測試記錄',
  "删除计划成功":'刪除計劃成功',
  "提前结束测试成功":'提前結束測試成功',
  "测试成绩导出":'測試成績導出',
  "全校":'全校',
  "部分":'部分',
  "（标准已删除）":'（標準已刪除）',
  "（标准已停用）":'（標準已停用）',
  "测试计划已结束":'測試計劃已結束，不可編輯哦',
  "数据来源":'數據來源',
  "是否自助测试":'​​是否自助測試',
  "是":'是',
  "否":'否',
  "测试方式":'測試方式',
  "校内组织":'​校內組織',
  "自助测试":'自助測試',
  "运动详情":'運動詳情​​',
  "运动视频片段":'​​運動影片片段',
  "运动过程图片":'​​運動過程圖像​',
  "录入":'錄入​​',
  '计划明细导入完成':'計劃明細匯入完成',
  '计划明细模板':'計劃明細範本​',
  '学生是否预约':'​學生是否預約​​',
  '可预约日期':' 可預約日期​​',
  '预约配置':'預約配置​​',
  '去设置':'​​前往設定​​',
  '去修改':'前往修改​',
  '跑步类项目可预约时段':'​跑步類項目可預約時段​​',
  '跑步类项目':'​跑步類項目',
  '非跑步类项目':'​非跑步類項目',
  '预约人数':'​預約人數​​',
  '非跑步类项目可预约时段':'​非跑步類項目可預約時段​​',
  '跑步类项目，如50':'跑步類項目，如50/800/1000米跑等',
  '非跑步类项目，如肺活量、仰卧起坐等':'非跑步類項目，如肺活量、仰臥起坐等​​',
  '预约配置不可为空':'預約配置不可為空​',
  '可预约时段不可为空':'​​可預約時段不可為空​​',
  '预约时段':'預約時段',
  '预约人数不可为空':'預約人數不可為空​​',
  '设置预约信息':'​設定預約資訊​​',
  '预约数据导出':'​匯出預約資料​',
  '预约数据':'​預約資料​',
  '项目分类':'項目分類',
  '该时段已有学生预约，删除将清空已有预约数据':'​此時段已有學生預約，刪除將清空已有預約數據​',
  '已有学生预约，切换预约模式清空已有预约数据':'已有學生預約，切換預約模式將清空已有預約數據',
  '作废':'作廢',
  '确定要作废此记录吗':'確定要作廢此記錄嗎',
  '请修改测试结果':'請修改測試結果',
  '请填写结果':'請填寫結果',
  '结果':'結果',
  '导出学生名单':'匯出學生名單​',
  '考生姓名':'考生姓名​',
  '预约详情':'預約詳情',
  '预约方式':'預約方式',
  '重复':'預約方式',
  '自定义':'自定義',
  '请选择重复天数':'請選擇重複天數',
  '选择日期':'選擇日期',
  '新增日期':'新增日期',
  '请选择测试时间和可预约日期':'請選擇測試時間和可預約日期',
  '可预约时段不可重复':'可預約時段不可重複',
  '存在重复可预约时段，请修改':'存在重複可預約時段，請修改',
  '预约学生名单':'預約學生名單',
  '最优成绩导入':'最優成績匯入',
}